import { INotificationSummaryProps } from '../interfaces/IStore';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type State = {
  notificationEmpty: boolean;
  notificationSummary: null | {
    page: number;
    totalPages: number;
    itens: INotificationSummaryProps[];
  };
};

type Actions = {
  addNotificationSummary: (notificationSummary: unknown) => void;
  addSingleNotificationSummary: (notificationSummary: unknown) => void;
  clearNotificationSummary: () => void;
  setEmptyNotification: () => void;
};

export const useSearchStore = create(
  immer<State & Actions>((set) => ({
    notificationEmpty: false,
    notificationSummary: null,
    addNotificationSummary: (notificationSummary: unknown) => set(() => ({ notificationSummary, notificationEmpty: false })),
    addSingleNotificationSummary: (notificationSummary: unknown) => set(() => ({
      notificationSummary: { itens: [notificationSummary] },
      notificationEmpty: false,
    })),
    clearNotificationSummary: () => set({ notificationSummary: null, notificationEmpty: false }),
    setEmptyNotification: () => set({ notificationEmpty: true }),
  })),
);
